export const hasValue = v => v !== undefined && v !== null && v !== '';

export const hasOptions = options => !!options?.filter(({ __isNew__ }) => !__isNew__).length;

export const stringifyValue = (value, delimiter = ',') =>  String(Array.isArray(value) ? value.filter(hasValue).join(delimiter) : hasValue(value) ? value : '');

export const flattenOptions = options => options?.reduce((prev, curr) => curr?.options?.length ? [...prev, ...curr?.options] : [...prev, curr], []);
//export const flattenOptions = options => options?.reduce((prev, curr) => curr?.options?.length ? [...prev, ...curr?.options] : hasValue(curr?.value) ? [...prev, curr] : prev, []);

export const filterOptions = (value, options, multiple) => flattenOptions(options)?.filter(o => multiple ? String(value).split(',').includes(String(o?.value)) : String(o?.value) === String(value));

export const filterSelectOptions = ({ label = '' }, i) => {
  const labelString = ['string', 'number', 'boolean'].includes(typeof label) ? String(label) : String(label?.props?.children[0] || '');
  return labelString.toLowerCase().includes(i.toLowerCase());
}
    
export const formatCreateLabel = (inputValue) => `Enter custom value '${inputValue}'`;

export const noOptionsMessage = () => 'No matching options';
      